import {NgModule} from '@angular/core';
import {AuthService} from './auth.service';
import {AuthGuard} from './auth.guard';
import {HasRoleDirective} from './has-role.directive';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    providers: [AuthService, AuthGuard],
    declarations: [HasRoleDirective],
    exports: [HasRoleDirective]
})
export class AuthModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/security/authorization/auth.module.ts